<template>
  <div>
    <top-header :type="6" placeholder="我的资料" fontSize="0.32rem" />
    <div class="form_con">
      <div class="inner_con">
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">头像</span>
          <div class="right m_flex_box flex_he flex_vc">
            <van-uploader :after-read="afterRead" :before-read="beforeRead">
              <img :src="defaultImg" alt="">
            </van-uploader>
           <!-- <van-icon name="arrow" />-->
          </div>
        </div>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">性别</span>
          <div class="right m_flex_box flex_he flex_vc" @click="showSex = true">
            <span>{{sex ? sex : '请选择'}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <van-popup v-model="showSex" position="bottom">
          <van-picker
            show-toolbar
            value-key="t"
            :columns="sexList"
            @confirm="confirmSex"
            @cancel="showSex = false"
          />
        </van-popup>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">籍贯</span>
          <div class="right m_flex_box flex_he flex_vc">
            <input type="text" placeholder="请输入" v-model="formData.nativePlace">
           <!-- <van-icon name="arrow" />-->
          </div>
        </div>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">文化程度</span>
          <div class="right m_flex_box flex_he flex_vc" @click="showCulture = true">
            <span>{{education ? education : '请选择'}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
      <van-popup v-model="showCulture" position="bottom">
        <van-picker
          show-toolbar
          value-key="t"
          :columns="educationList"
          @confirm="confirmCulture"
          @cancel="showCulture = false"
        />
      </van-popup>
      <div class="inner_con">
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">职业</span>
          <div class="right m_flex_box flex_he flex_vc" @click="showOccupation = true">
            <span>{{occupation ? occupation : '请选择'}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <van-popup v-model="showOccupation" position="bottom">
          <van-picker
            show-toolbar
            value-key="t"
            :columns="occupationList"
            @confirm="confirmOccupation"
            @cancel="showOccupation = false"
          />
        </van-popup>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">公司类别</span>
          <div class="right m_flex_box flex_he flex_vc" @click="showCompany = true">
            <span>{{company ? company : '请选择'}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <van-popup v-model="showCompany" position="bottom">
          <van-picker
            show-toolbar
            value-key="t"
            :columns="companyList"
            @confirm="confirmCompany"
            @cancel="showCompany = false"
          />
        </van-popup>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">工作地/常住地</span>
          <div class="right m_flex_box flex_he flex_vc">
            <input type="text" placeholder="请输入" v-model="formData.permanentResidence">
           <!-- <van-icon name="arrow" />-->
          </div>
        </div>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">收入状况</span>
          <div class="right m_flex_box flex_he flex_vc" @click="showIncome = true">
            <span>{{income ? income : '请选择'}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <van-popup v-model="showIncome" position="bottom">
          <van-picker
            show-toolbar
            value-key="t"
            :columns="incomeList"
            @confirm="confirmIncome"
            @cancel="showIncome = false"
          />
        </van-popup>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">婚姻状况</span>
          <div class="right m_flex_box flex_he flex_vc" @click="showMaritalStatus = true">
            <span>{{maritalStatus ? maritalStatus : '请选择'}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <van-popup v-model="showMaritalStatus" position="bottom">
          <van-picker
            show-toolbar
            value-key="t"
            :columns="maritalStatusList"
            @confirm="confirmMaritalStatus"
            @cancel="showMaritalStatus = false"
          />
        </van-popup>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">子女状况</span>
          <div class="right m_flex_box flex_he flex_vc" @click="showChildren = true">
            <span>{{children ? children : '请选择'}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <van-popup v-model="showChildren" position="bottom">
          <van-picker
            show-toolbar
            value-key="t"
            :columns="childrenList"
            @confirm="confirmChildren"
            @cancel="showChildren = false"
          />
        </van-popup>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">政治面貌</span>
          <div class="right m_flex_box flex_he flex_vc" @click="showPoliticsStatus = true">
            <span>{{politicsStatus ? politicsStatus : '请选择'}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <van-popup v-model="showPoliticsStatus" position="bottom">
          <van-picker
            show-toolbar
            value-key="t"
            :columns="politicsStatusList"
            @confirm="confirmPoliticsStatus"
            @cancel="showPoliticsStatus = false"
          />
        </van-popup>
      </div>
      <div class="inner_con">
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">手机号</span>
          <div class="right m_flex_box flex_he flex_vc" @click="updatePhone">
            <span>{{formData.phone | capitalize}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <!-- <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">微信绑定</span>
          <div class="right m_flex_box flex_he flex_vc">
            <span>{{formData.phone ? formData.phone : '未绑定'}}</span>
            <van-icon name="arrow" />
          </div>
        </div> -->
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">腾讯QQ</span>
          <div class="right m_flex_box flex_he flex_vc">
            <input type="number" placeholder="请输入" v-model="formData.qqNum">
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="row m_flex_box flex_vc flex_jz">
          <span class="tit">电子邮箱</span>
          <div class="right m_flex_box flex_he flex_vc">
            <input type="text" placeholder="请输入" v-model="formData.email">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
      <div class="inner_con">
        <router-link to="/appXieyi" class="row m_flex_box flex_vc flex_jz">
          <span class="tit">隐私协议</span>
          <div class="right m_flex_box flex_he flex_vc">
            <span>查看</span>
            <van-icon name="arrow" />
          </div>
        </router-link>
      </div>
    </div>
    <div class="btn_con m_flex_box flex_ar">
      <div class="btn" @click="loginout">退出登录</div>
      <div class="btn_" @click="saveInfo">保存信息</div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import topHeader from '@/components/header'
import { mapGetters } from "vuex"
export default {
  data() {
    return {
      sex: '',
      education: '',
      occupation: '',
      company: '',
      income: '',
      maritalStatus: '',
      children: '',
      politicsStatus: '',
      formData: {
        sex: '',
        education: '',
        occupation: '',
        company: '',
        income: '',
        maritalStatus: '',
        children: '',
        politicsStatus: '',
        nativePlace: '',
        permanentResidence: '',
        qqNum: '',
        phone: '',
        email: '',
      },
      showCulture: false,
      showSex: false,
      showOccupation: false,
      showCompany: false,
      showIncome: false,
      showMaritalStatus: false,
      showChildren: false,
      showPoliticsStatus: false,
      educationList: [{
        v: 0,
        t: '高中及以下'
      },{
        v: 1,
        t: '大专'
      },{
        v: 2,
        t: '本科'
      },{
        v: 3,
        t: '研究生'
      },{
        v: 4,
        t: '博士及以上'
      }],
      sexList: [{
        v: 1,
        t: '女'
      },{
        v: 0,
        t: '男'
      }],
      occupationList: [{
        v: 1,
        t: '国家机关、党群组织、企业、事业单位负责人'
      },{
        v: 2,
        t: '专业技术人员'
      },{
        v: 3,
        t: '办事人员和有关人员'
      },{
        v: 4,
        t: '商业、服务业人员'
      },{
        v: 5,
        t: '农、林、牧、渔、水利业生产人员'
      },{
        v: 6,
        t: '生产、运输设备操作人员及有关人员'
      },{
        v: 7,
        t: '军人'
      },{
        v: 8,
        t: '不便分类的其他从业人员'
      }],
      companyList: [{
        v: 1,
        t: '国有企业'
      },{
        v: 2,
        t: '国有控股企业'
      },{
        v: 3,
        t: '外资企业'
      },{
        v: 4,
        t: '合资企业'
      },{
        v: 5,
        t: '私营企业(又称民营企业)'
      },{
        v: 6,
        t: '事业单位'
      },{
        v: 7,
        t: '国家行政机关'
      },{
        v: 8,
        t: '政府'
      },{
        v: 9,
        t: '其他'
      }],
      incomeList: [{
        v: 1,
        t: '3000及以下'
      },{
        v: 2,
        t: '3000~5000元'
      },{
        v: 3,
        t: '5000~8000元'
      },{
        v: 4,
        t: '8000~12000元'
      },{
        v: 5,
        t: '12000~20000元'
      },{
        v: 6,
        t: '20000~50000元'
      },{
        v: 7,
        t: '50000元及以上'
      }],
      maritalStatusList: [{
        v: 1,
        t: '已婚'
      },{
        v: 2,
        t: '未婚'
      },{
        v: 3,
        t: '离异'
      }],
      childrenList: [{
        v: 1,
        t: '暂无子女'
      },{
        v: 2,
        t: '一名子女'
      },{
        v: 3,
        t: '两名子女'
      },{
        v: 4,
        t: '多名子女'
      }],
      politicsStatusList: [{
        v: 1,
        t: '群众'
      },{
        v: 2,
        t: '团员'
      },{
        v: 3,
        t: '中共党员'
      },{
        v: 4,
        t: '其他党派人士'
      }],
      defaultImg: require('@/assets/img/tx.jpg')
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: {
    topHeader
  },
  filters: {
    capitalize: function (value) {
      if (!value) return '未绑定'
      value = value.toString()
      return value.substring(0,3)+"****"+value.substring(value.length-4)
    }
  },
  mounted() {
    this.getUserInfo()
  },
  methods: {
    loginout() {
      this.$http.post('cms/onlineUser/reg/onlineUserloginOut.do').then(res => {
        this.$toast('退出成功');
        this.$store.dispatch('saveInfo', {});
        setTimeout(() => {
          this.$router.replace('/home')
        }, 1000)
      })
    },
    updatePhone() {
      this.$dialog.confirm({
        title: "提示",
        message: "请确保已保存修改的信息后再修改手机号",
        confirmButtonColor: "#2F72F5",
      }).then(() => {
        this.$router.push({
          path: '/testPhone',
          query: {
            phone: this.formData.phone
          }
        })
      }).catch(() => {})
    },
    getUserInfo() {
      this.$http.post('cms/onlineUser/reg/getOnlineUser.do').then(res => {
        for(let key in this.formData) {
          this.$set(this.formData, key, res.obj[key]);
          if(key !== 'nativePlace' && key !== "permanentResidence" && key !== 'qqNum' && key !== 'phone' && key !== 'email') {
            this[key + 'List'].forEach(item => {
              if(res.obj[key] == item['v']) {
                this[key] = item.t
              }
            })
          }
        }
        if(res.obj.txId) {
          this.defaultImg = this.imgPath + 'sTx/' +  res.obj.txId + '.jpg'
        }
      })
    },
    confirmSex(data) {
      this.sex = data.t;
      this.$set(this.formData, 'sex', data.v)
      this.showSex = false;
    },
    confirmCulture(data) {
      this.education = data.t;
      this.$set(this.formData, 'education', data.v)
      this.showCulture = false;
    },
    confirmOccupation(data) {
      this.occupation = data.t;
      this.$set(this.formData, 'occupation', data.v)
      this.showOccupation = false;
    },
    confirmCompany(data) {
      this.company = data.t;
      this.$set(this.formData, 'company', data.v)
      this.showCompany = false;
    },
    confirmIncome(data) {
      this.income = data.t;
      this.$set(this.formData, 'income', data.v)
      this.showIncome = false;
    },
    confirmMaritalStatus(data) {
      this.maritalStatus = data.t;
      this.$set(this.formData, 'maritalStatus', data.v)
      this.showMaritalStatus = false;
    },
    confirmChildren(data) {
      this.children = data.t;
      this.$set(this.formData, 'children', data.v)
      this.showChildren = false;
    },
    confirmPoliticsStatus(data) {
      this.politicsStatus = data.t;
      this.$set(this.formData, 'politicsStatus', data.v)
      this.showPoliticsStatus = false;
    },
    saveInfo() {
      if(this.formData.email && !/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(this.formData.email)) {
        this.$toast('请输入正确的邮箱号');
        return;
      }
      this.$http({
        url: 'cms/onlineUser/reg/perfectOnlineUser.do',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: this.formData
      }).then(res => {
        if(res.success) {
          this.$toast('保存成功')
        } else {
          this.$toast('保存失败，请稍后重试')
        }
      })
    },
    afterRead(file) {
      this.$http({
        url: 'cms/onlineUser/reg/updateUserTX.do',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data: file.content.split('base64,')[1]
      }).then(res => {
        if(res.success) {
          this.$toast('头像修改成功')
          this.defaultImg = file.content;
          let userInfo = this.userInfo;
          userInfo.txId = res.obj.txId
          this.$store.dispatch('saveInfo', userInfo);
        } else {
          this.$toast('头像修改失败')
        }
      })
    },
    beforeRead(file) {
      if (file.type.toLowerCase() !== 'image/jpg' && file.type.toLowerCase() !== 'image/png' && file.type.toLowerCase() !== 'image/jpeg' && file.type.toLowerCase() !== 'image/gif') {
        this.$toast('该格式不支持');
        return false;
      } else if (file.size > 5000 * 1024) {
        this.$toast('文件大小不得超过5M');
        return false;
      }
      return true;
    }
  },
};
</script>
<style lang="less" scoped>
  .form_con{
    border-top: 0.16rem solid #f5f5f5;
    .inner_con{
      border-bottom: 0.16rem solid #f5f5f5;
      .row{
        border-bottom: 1px solid #f5f5f5;
        padding: 0.3rem 0.28rem;
        font-size: 0.28rem;
        .tit{
          color: #333;
        }
        .right{
          width: 70%;
          color: #909090;
          img{
            width: 0.76rem;
            height: 0.76rem;
            border-radius: 50%;
          }
          i{
            margin-left: 0.24rem;
          }
        }
      }
    }
  }
  .btn_con{
    padding: 0.22rem 0.1rem 0.44rem;
    background-color: #f5f5f5;
    >div{
      text-align: center;
      font-size: 0.28rem;
      width: 45%;
      line-height: 0.88rem;
      border-radius: 0.08rem;
      box-sizing: border-box;
    }
  }
  .btn{
    background-color: #2F72F5;
    color: #fff;
  }
  .btn_{
    border: 1px solid #2F72F5;
    color: #2F72F5;
  }
  input{
    text-align: right;
  }
  input::-webkit-input-placeholder {
    color:#909090;
  }
  input::-moz-input-placeholder {
    color:#909090;
  }
  input::-ms-input-placeholder {
    color:#909090;
  }
</style>